import DashView from "./components/Dash.vue";
import NotFoundView from "./components/404.vue";

// Routes
const routes = [
  {
    path: "/",
    component: DashView,
  },
  {
    // not found handler
    path: "*",
    component: NotFoundView
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js